/**************************************************
 * Nombre:       Home_Por_Categoria
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import TituloHuella from "./SubComponentes/TituloHuella";
import {useSeleccion} from "./SubComponentes/Hooks/useSeleccion";
import Lista_Productos from "./Lista_Productos";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../../Servicios/BD/obtenerCol";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../../Servicios/BD/obtenerColWheres";

const Home_Por_Categoria = () => {
    const {sCell} = useResponsive()
    const [categorias, setCategorias] = useState([])
    const {Lista, seleccionado} = useSeleccion({lista: categorias})
    const [productos, setProductos] = useState([])

    useEffect(() => {

        if (seleccionado) {
            let w = [where('categoria', '==', seleccionado)]
            obtenerColWheres({col: 'productos', wheres: w}).then((dox) => {
                if (dox.res) {
                    setProductos(dox.data);
                }
            })
        }


    }, [seleccionado])

    useEffect(() => {

        obtenerCol('categorias').then((dox) => {
            if (dox.res) {
                setCategorias(dox.data.map((it) => it.nombre))
            }
        })


    }, [])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <TituloHuella titulo={'Por Categoria'}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 6}}
                              sx={{justifyContent: 'flex-end', mt: sCell ? 4 : 0}}>
                            <Lista/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 10}}>
                            <Lista_Productos items={productos}/>
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Por_Categoria